export const Close = ({ width = '32', height = '32', fill = '#fff' }: React.SVGProps<SVGSVGElement>) => (
	<svg width={width} height={height} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M5.56757 5.56781C5.87999 5.25539 6.38652 5.25539 6.69894 5.56781L15.9999 14.8688L25.3009 5.56781C25.6133 5.25539 26.1199 5.25539 26.4323 5.56781C26.7447 5.88023 26.7447 6.38676 26.4323 6.69918L17.1313 16.0002L26.4323 25.3011C26.7447 25.6136 26.7447 26.1201 26.4323 26.4325C26.1199 26.7449 25.6133 26.7449 25.3009 26.4325L15.9999 17.1315L6.69894 26.4325C6.38652 26.7449 5.87999 26.7449 5.56757 26.4325C5.25515 26.1201 5.25515 25.6136 5.56757 25.3011L14.8685 16.0002L5.56757 6.69918C5.25515 6.38676 5.25515 5.88023 5.56757 5.56781Z"
			fill={fill}
		/>
	</svg>
);
